// extracted by mini-css-extract-plugin
module.exports = {"collapsableHeader":"collapsableHeader___1tJ_F","headerHeader":"headerHeader___2KXlf","image":"image___-hb_D","headerText":"headerText___2jiHx","collapsed":"collapsed___3L5dh"};